import React from 'react';
import { Dashboard } from '../../components/navigation/Dashboard';
import { MySurveys } from '../../components/navigation/MySurveys';
import { Pricing } from '../../components/navigation/Pricing';
import { TeamMenu } from '../../components/navigation/TeamMenu';
import ButtonCreate from '../../components/actions/ButtonCreate';
import ButtonUser from '../../components/actions/ButtonUser';
import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';
import { Variant } from '../types';

const analyze: Variant = {
  brand: 'SurveyMonkey',
  menu: [
    <Dashboard key="menu-dashboard" />,
    <MySurveys key="menu-home" />,
    <TeamMenu key="menu-team" />,
    <Pricing key="menu-pricing" />,
  ],
  actions: [
    <ButtonUser key="action-user" />,
    <ButtonCreate key="action-create" />,
  ],
  info: [<InfoMenu key="menu-info" />],
  user: [<UserMenu key="menu-user" />],
  homePage: '/pricing/',
};

export default analyze;
